
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#2F80ED"}}),_c('path',{attrs:{"d":"M11 25.954V16.82c0-.684.334-1.323.89-1.703l7-4.773a1.963 1.963 0 012.22 0l7 4.773c.556.38.89 1.019.89 1.703v9.134m-18 0c0 1.13.895 2.046 2 2.046h14c1.105 0 2-.916 2-2.046m-18 0l6.75-4.603M29 25.954l-6.75-4.603M11 16.748l6.75 4.603M29 16.748l-6.75 4.603m0 0l-1.14.778a1.963 1.963 0 01-2.22 0l-1.14-.778","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    